import { render, staticRenderFns } from "./GCheckableItemListItem.vue?vue&type=template&id=52cabd6a&scoped=true&"
import script from "./GCheckableItemListItem.vue?vue&type=script&lang=ts&"
export * from "./GCheckableItemListItem.vue?vue&type=script&lang=ts&"
import style0 from "./GCheckableItemListItem.vue?vue&type=style&index=0&id=52cabd6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cabd6a",
  null
  
)

export default component.exports